import { Select } from "antd";
import "./VisitorLeadsFilters.css";
import React, { useState } from "react";

const VisitorLeadsFilters = ({
  sortVisitorList,
  filtersList,
  GetUpdatedVisitorLeads,
  selectedFilter,
  setSelectedFilter,
  selectedFilterValue,
  setSelectedFilterValue
}) => {
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  // const [selectedFilter, setSelectedFilter] = useState([]);
  // const [selectedFilterValue, setSelectedFilterValue] = useState([]);

  return (
    <div className="visitor-leads-filter pb-3 mb-3 border-bottom">
      <div className="visitor-input-header">
        <div className="d-flex gap-2 flex-wrap input-row">
          <label>Sort By - </label>
          <div className="h-100">
            {/* <label>Select Field</label> */}
            <Select
              placeholder="Select Field"
              className="w-100"
              value={sortField ? [sortField] : []}
              onChange={(value) => setSortField(value)}>
              <Select.Option value="fld_first_name">Name</Select.Option>
              <Select.Option value="fld_email_address">
                Email Address
              </Select.Option>
              <Select.Option value="fld_country">Country</Select.Option>
              <Select.Option value="budget">Budget</Select.Option>
            </Select>
          </div>
          <div>
            {/* <label>Select Order</label> */}
            <Select
              placeholder="Select Order"
              className="w-100"
              value={sortOrder ? [sortOrder] : []}
              onChange={(value) => setSortOrder(value)}>
              <Select.Option value="Asc">A - Z</Select.Option>
              <Select.Option value="Desc">Z - A</Select.Option>
            </Select>
          </div>
          <button
            type="button"
            className="visitor-btn"
            onClick={() => sortVisitorList(sortField, sortOrder)}>
            Sort
          </button>
        </div>

        <div
          style={{
            display: "flex",
            gap: 10,
            alignItems: "center",
            flexWrap: "wrap",
          }}>
          <div
            className="d-flex justify-content-between input-row"
            style={{
              columnGap: "12px",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 10,
            }}>
            <label>Filter By - </label>

            <div className="filter-list">
              {filtersList?.map((det, index) => {
                const optionsList = det?.list ? JSON.parse(det?.list) : [];

                return (
                  <div key={index}>
                    <Select
                      placeholder={det?.type}
                      className="w-100"
                      value={selectedFilterValue[index] || undefined}
                      onChange={(value, option) => {
                        const updated = [...selectedFilter];
                        const updatedValue = [...selectedFilterValue];
                        if (option?.key === 'fld_city_of_interest' || option?.key === 'fld_property_type') {
                          updated[index] = option?.key + " LIKE " + `'%${value}%'`;
                        } else {
                          updated[index] = option?.key + " = " + `'${value}'`;
                        }
                        updatedValue[index] = value;

                        setSelectedFilter(updated);
                        setSelectedFilterValue(updatedValue);
                      }}>
                      {optionsList?.map((item, i) => (
                        <Select.Option
                          key={item?.option_name}
                          value={item?.value}>
                          {item?.value}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                );
              })}
            </div>

            {/* } */}
          </div>

          <div
            className="input-row"
            style={{
              display: "flex",

              alignItems: "center",
              gap: 10,
            }}>
            <button
              type="button"
              className="visitor-btn"
              onClick={() => {
                if (!selectedFilter?.length) return;
                const filteredUndefined = selectedFilter?.filter((det) => det);
                GetUpdatedVisitorLeads(filteredUndefined?.join(" and "));
              }}>
              Filter
            </button>

            {/* {(selectedFilter?.length > 0) && */}
            <button
              type="button"
              className="visitor-btn"
              onClick={() => {
                if (selectedFilter?.length > 0) {
                  setSelectedFilter([]);
                  setSelectedFilterValue([]);
                  GetUpdatedVisitorLeads();
                }
              }}>
              Clear
            </button>
          </div>
        </div>
      </div>

      {/* search input and btn */}
      {/* <div className='d-flex gap-2 justify-content-end align-items-center mt-3'>

				<div className='d-flex justify-content-center align-items-center gap-2'>
					<input
						type="text"
						className="form-control visitor-input"
					// onChange={(e) => handleOnChange('firstName', e.target.value)}
					// readOnly={isDisable}
					/>

					<button
						type="button"
						className="visitor-btn"
						onClick={() => {
							// if (!selectedFilter?.length) return;
							// const filteredUndefined = selectedFilter?.filter(det => det);
							// GetUpdatedVisitorLeads(filteredUndefined?.join(' and '))
						}}
					>
						Search
					</button>

				</div>
			</div> */}
    </div>
  );
};

export default VisitorLeadsFilters;
